import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_activity_participant_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  activity_registration_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  phone_num: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class bl_crm_activity_participant_RowClass implements bl_crm_activity_participant_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  activity_registration_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  phone_num: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}


